/* empty css         */
import "./index291.js";
/* empty css         */
/* empty css         */
/* empty css         */
/* empty css         */
/* empty css         */
import { defineComponent as p, openBlock as s, createBlock as r, normalizeClass as m } from "vue";
import { ElDatePicker as n } from "./index297.js";
const k = /* @__PURE__ */ p({
  __name: "BaseInputCalendar",
  props: {
    modelValue: { default: void 0 },
    placeholder: { default: "YYYY-MM-DD" },
    disabled: { type: Boolean, default: !1 },
    disabledDate: { type: Function, default: void 0 },
    size: { default: "sm" }
  },
  emits: ["update:modelValue", "change"],
  setup(t, { emit: d }) {
    const e = t, l = d, o = (a) => {
      l("update:modelValue", a), l("change", a);
    };
    return (a, c) => {
      const i = n;
      return s(), r(i, {
        "model-value": e.modelValue,
        type: "date",
        placeholder: e.placeholder,
        class: m(["input-date", `el-input--${e.size}`]),
        format: "YYYY-MM-DD",
        "value-format": "YYYY-MM-DD",
        disabled: e.disabled,
        "disabled-date": e.disabledDate,
        "onUpdate:modelValue": o,
        editable: !1,
        clearable: !1
      }, null, 8, ["model-value", "placeholder", "class", "disabled", "disabled-date"]);
    };
  }
});
export {
  k as default
};
